import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="bg-navy-900 text-cream-50 py-14 md:py-20 relative" data-id="element-264">
      <div className="container mx-auto px-4" data-id="element-265">
        <div className="max-w-[720px] mx-auto" data-id="element-266">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-267">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-268" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-269" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-270" />
          </div>
          <FadeIn data-id="element-271">
            <p className="mb-6 leading-relaxed text-lg text-cream-100/90" data-id="element-272">
              Para el hombre mayor de 45 años, la próstata no es solo un órgano;
              es el interruptor que decide si tendrás un buen día o una jornada
              de fatiga crónica.
            </p>
            <p className="mb-6 leading-relaxed text-lg text-cream-100/90" data-id="element-273">
              La mayoría de los hombres hacen lo obvio… y fallan: "bebo menos
              agua", "me tomo un suplemento", "ya se me pasará".
            </p>
            <p className="mb-6 leading-relaxed text-lg text-cream-100/90" data-id="element-274">
              El problema real no es solo el tamaño de tu próstata. Es la
              combinación mortal de: una vejiga hiperreactiva, y tu cena
              nocturna activando señales de urgencia como si tu cuerpo estuviera
              en alarma.
            </p>
            <p className="mb-12 leading-relaxed text-lg font-semibold text-gold-400" data-id="element-275">
              Lo que comiste anoche no fue "normal". Fue gasolina para el fuego.
              Y tu sueño paga el precio.
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-276">
            <div className="bg-navy-800 rounded-2xl p-8 md:p-10 border border-navy-700 shadow-xl" data-id="element-277">
              <h3 className="text-2xl font-heading font-bold text-white mb-6" data-id="element-278">
                Por qué lo que has intentado no funciona
              </h3>
              <div className="space-y-6 text-cream-100/90 text-lg" data-id="element-279">
                <p data-id="element-280">
                  Los suplementos de farmacia muchas veces traen rellenos y
                  fórmulas genéricas que no atacan el disparador nocturno.
                </p>
                <p data-id="element-281">
                  Beber menos agua deshidrata tus células y concentra la orina:
                  más irritación, más espasmos, más urgencia.
                </p>
                <p data-id="element-282">
                  Los medicamentos recetados pueden ayudar, pero a muchos
                  hombres les dejan un costo oculto: efectos secundarios que
                  golpean energía, ánimo y desempeño.
                </p>
                <p className="font-bold text-red-400 mt-6" data-id="element-283">
                  Y lo peor: si lo ignoras, tu vejiga aprende a "gritar" cada
                  vez más temprano… hasta que dormir se vuelve un lujo.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}